var date = {
  "abbr_day_names": ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
  "abbr_month_names": [null, "jan.", "fév.", "mar.", "avr.", "mai", "juin", "juil.", "août", "sept.", "oct.", "nov.", "déc."],
  "day_names": ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
  "formats": {
    "default": "%d/%m/%Y",
    "short": "%e %b",
    "long": "%e %B %Y",
    "datepicker2": "%d %b %Y",
    "short_day": "%a %e %b",
    "month_year": "%b %Y",
    "day_only": "%d",
    "long_month_only": "%B",
    "long_year_only": "%Y",
    "long_month_year": "%B %Y",
    "myenlighten_month": "%m/%Y",
    "graph": {
      "long": "%a %e %b %Y",
      "x_axis": {
        "day": "%e-%b",
        "week": "%e-%b"
      }
    },
    "jquery": {
      "datepicker": "d/m/y",
      "datepicker2": "d M yy",
      "power_playback": "ddd d MMM yyyy HH:mm",
      "myenlighten": "dd/mm/yyyy",
      "datejs_formatter": "dd/M/yyyy",
      "myenlighten_month": "mm/yyyy",
      "myenlighten_overview": "D, d M yyyy",
      "datejs_month_formatter": "M/yyyy"
    },
    "js": {
      "short_month": "%b",
      "short_day_year": "%a %e %b %Y",
      "short_month_day": "%e&nbsp;%B&nbsp;%Y",
      "short_month_day_time": "%e %B %Y – %H:%M"
    }
  },
  "month_names": [null, "janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"],
  "order": ["day", "month", "year"],
  "range": {
    "presets": {
      "today": "Aujourd'hui",
      "last7Days": "7 derniers jours",
      "monthToDate": "Depuis le début du mois",
      "yearToDate": "Depuis le début d'année"
    }
  }
};
module.exports = date;